if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('.free-shipping-bar__fill');
      if (!fill) return;

      const target = parseFloat(this.dataset.percent) || 0;
      const previous = window.freeShippingBarPercent;
      window.freeShippingBarPercent = target;

      if (typeof previous !== 'number' || previous === target) return;

      fill.style.transition = 'none';
      fill.style.width = previous + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(() => {
        fill.style.width = target + '%';
      });
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}